import { BaseMutations } from '@/store/base-mutations';
import RetroBonusesState from './state';
import { RetroBonuses, RetroBonusesFilters } from '../types';

export default class RetroBonusesMutations extends BaseMutations<RetroBonusesState> {
  SET_RETRO_BONUSES(items: RetroBonuses.RetroBonus[]) {
    this.state.retro_bonuses = items;
  }

  SET_REWARD_DOCUMENTS(items: RetroBonuses.RewardDocument[]) {
    this.state.reward_documents = items;
  }

  SET_REWARD_DOCUMENT_DETAIL(items: RetroBonuses.RewardDocumentDetail) {
    this.state.reward_document_details = items;
  }

  SET_REWARD_DOCUMENT_PRODUCTS(items: RetroBonuses.RewardDocumentProducts[]) {
    this.state.reward_document_products = items;
  }

  SET_CONTRACT_INFO(items: RetroBonuses.Contract) {
    this.state.contract_info = items;
  }

  SET_SCENARIOS(items: RetroBonuses.RetroScenarios[]) {
    this.state.scenarios = items;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof RetroBonusesFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  UPD_REWARD_DOCUMENTS_FILTER_KEY({ key, value }: { key: keyof RetroBonusesFilters, value: unknown }) {
    this.state.reward_documents_filters[key] = value;
  }

  TOGGLE_RETRO_BONUSES_LOADING(value: boolean) {
    this.state.retro_bonuses_loading = value;
  }

  SET_ORGANIZATIONS(items: string[]) {
    this.state.organizations = items;
  }
}
